module.exports = __webpack_public_path__ + "media/images/illustrations/online-tutoring-02-fe6df525e022192b62e6f97a41a5686d.svg";